// ie fixes
import "whatwg-fetch";
import "@babel/polyfill";

// forEach pollyfill
if (typeof NodeList.prototype.forEach !== "function") {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

// Create Element.remove() function if not exist
if (!("remove" in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

/***** components *****/
import "./bw/menu";
import Panel from "./bw/interactivePanel";
import CollectionBar from "./bw/collectionBar";
import CollectionModal from "./bw/collectionModal";
import Selectable from "./bw/selectable";
import carouselInit from "./bw/carousel";
import Collection from "./bw/collection";
import SpinnerButton from "./bw/spinnerButton";
import { Filters } from "./bw/filters";
import { showModal, hideModal, autoShowModal } from "./bw/modal";
import Swatches from "./bw/swatches";
import CollectionSlider from "./common/collectionSlider";
import Form from "./common/form";
import sampleOrderCart from "./common/sampleOrderCart";
import checkout from "./common/checkout";
import loadCollectionListeners from "./common/showcasePage";
import { addListeners } from "./common/collectionPage";
import LoadMorePage from "./bw/loadMorePage";

document.addEventListener("DOMContentLoaded", () => {
    window.stagedProducts = new Set();

    // collection
    // Should pass this into each component instead of making it global
    window.collection = new Collection();
    window.collection.load();
    window.collection.updateCount();

    const collection_bar = new CollectionBar();
    const swatches = new Swatches({
        collection_bar: collection_bar
    });

    const collection_modal = new CollectionModal({
        collection_bar: collection_bar
    });

    const panel = new Panel({
        panel: document.querySelector(".interactive-panel"),
        collection_bar: collection_bar
    });

    const load_more_more = document.querySelector(".load-more-more");

    if (load_more_more) {
        const load_more = new LoadMorePage(load_more_more);
    }

    let spinner_buttons = [...document.querySelectorAll(".spinner-button")];

    if (spinner_buttons.length > 0) {
        spinner_buttons.map(el => {
            new SpinnerButton({
                el: el,
                collection: window.collection
            });
        });
    }

    let selectable = [...document.querySelectorAll(".selectable")];

    if (selectable.length > 0) {
        selectable.map(s => {
            new Selectable({
                el: s,
                collection_bar: collection_bar
            });
        });
    }

    // collection page
    const scrollPosition = document.querySelectorAll(".scroll-position");

    if (scrollPosition) {
        scrollPosition.forEach(s => {
            s.addEventListener("click", () => {
                sessionStorage.setItem("scrollP", window.scrollY);
            });
        });
    }

    if (sessionStorage.getItem("scrollP")) {
        window.scrollTo({
            top: sessionStorage.getItem("scrollP")
        });
        sessionStorage.removeItem("scrollP");
    }

    addListeners();
    window.loadCollectionListeners = loadCollectionListeners;
    window.loadCollectionListeners();

    // modal
    window.showModal = showModal;
    window.hideModal = hideModal;
    autoShowModal();
    
    window.addEventListener("popstate", function(e) {
      autoShowModal();
    });
    
    // carousel
    const carousels = document.querySelectorAll("[data-carousel]");
    if (carousels) {
        carousels.forEach(carouselInit);
    }
    
    // product filters
    const filters = [...document.querySelectorAll(".refine-filters")];

    if (filters.length > 0) {
        filters.forEach(filter => {
            new Filters(filter);
        });
    }

    // collection sliders
    if (document.getElementsByClassName("collection-grid")) {
        let collectionGrids = document.getElementsByClassName(
            "collection-grid"
        );
        for (let grid of collectionGrids) {
            new CollectionSlider(grid);
        }
    }

    // sample cart
    if (document.querySelector(".SampleOrderCart")) {
        sampleOrderCart();
    }

    // checkout
    if (document.querySelector("#checkout-form")) {
        checkout();
    }

    // form functionality and validation
    const forms = document.querySelectorAll("[data-form-validation]");
    if (forms) {
        for (let form of forms) {
            new Form(form).load();
        }
    }

    // form functionality and validation
    const numberInputs = document.querySelectorAll(".form-number");
    if (numberInputs) {
        numberInputs.forEach(numberInput => {
            let input = numberInput.querySelector('input[type="number"]'),
                btnUp = numberInput.querySelector(".quantity-up"),
                btnDown = numberInput.querySelector(".quantity-down"),
                min = input.min,
                max = input.max,
                newVal;

            btnUp.addEventListener("click", function customEvent(event) {
                input = numberInput.querySelector('input[type="number"]');
                var oldValue = parseInt(input.value);
                if (oldValue >= max) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue + 1;
                }
                input.value = `${newVal}`;

                fetch("/umbraco/surface/cart/savecartitem", {
                    method: "POST",
                    body: JSON.stringify({
                        sku: input.dataset.sku,
                        quantity: newVal
                    }),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => {
                        return res.json();
                    })
                    .then(res => {
                        const cartCount = [...document.querySelectorAll(".js-cart-count")];
                        cartCount.map(cc => { cc.innerHTML = res.TotalCartCount });
                    });
            });

            btnDown.addEventListener("click", function customEvent() {
                input = numberInput.querySelector('input[type="number"]');
                var oldValue = parseFloat(input.value);
                if (oldValue <= min) {
                    newVal = oldValue;
                } else {
                    newVal = oldValue - 1;
                }
                input.value = `${newVal}`;

                fetch("/umbraco/surface/cart/savecartitem", {
                    method: "POST",
                    body: JSON.stringify({
                        sku: input.dataset.sku,
                        quantity: newVal
                    }),
                    credentials: "same-origin",
                    headers: {
                        "Content-Type": "application/json"
                    }
                })
                    .then(res => {
                        return res.json();
                    })
                    .then(res => {
                        const cartCount = [...document.querySelectorAll(".js-cart-count")];
                        cartCount.map(cc => { cc.innerHTML = res.TotalCartCount });
                    });
            });
        });
    }
});

// Loading state managed app
// Unfinished, this is the format of how things should be set updateCount
// each interactive element should be a component
// the components should trigger state changes
// if needed their render should output content from the state
// the pubsub system will keep components up to date
// Read: https://css-tricks.com/build-a-state-management-system-with-vanilla-javascript/
// window.debug = false;
// import "./bw/state/store/main";
